export const isBillingAddressUpdateRequiredError = (error: any): boolean => {
  if (error?.code !== 9 || !error?.message) {
    return false;
  }

  let message = error.message;

  // Handle gRPC style prefix if present (e.g., "FAILED_PRECONDITION: { ... }")
  const msgParts = message.split(':');
  if (msgParts.length > 1 && /^[A-Z_]+$/.test(msgParts[0].trim())) {
    message = msgParts.slice(1).join(':').trim();
  }

  try {
    const errorObj = JSON.parse(message);
    return (
      errorObj.code === 4000 ||
      (errorObj.msg && errorObj.msg.toLowerCase().includes('billing address details'))
    );
  } catch (e) {
    return false;
  }
};

export const parseApiErrorMessage = (error: any): string => {
  if (!error?.message) return '';

  let message = error.message;

  // Handle gRPC style prefix
  const msgParts = message.split(':');
  if (msgParts.length > 1 && /^[A-Z_]+$/.test(msgParts[0].trim())) {
    message = msgParts.slice(1).join(':').trim();
  }

  try {
    const errorObj = JSON.parse(message);
    return errorObj.msg || message;
  } catch (e) {
    return message;
  }
};
